import { SWRResponse } from "swr";
import useQuery, {
  UseQueryOptions
} from "rivals/shared/hooks/useQuery/useQuery";
import { Request, Response } from "./types";

export default function useGetGallery(
  requestParams: Request,
  options?: UseQueryOptions
): SWRResponse<Response> {
  const url = `/api/v2/content/galleries/${requestParams.galleryId}`;
  return useQuery<Response>(url, options);
}
